import React from 'react';
import './sendEmailConfirmationDialog.scss';
import PropTypes from 'prop-types';
import FormDialog from '../../../../../Components/Modal/modal';
import alertIcon from '../../../../../Assets/images/svg/alert_icon.svg';
import {
  TECH_SESSION_SEND_EMAIL,
  CANCEL_TEXT,
} from '../../../../../Constants/strings';

const SendEmailConfirmationDialog = ({ open, onClose, onConfirm }) => (
  <FormDialog
    open={open}
    title={TECH_SESSION_SEND_EMAIL.SEND_EMAIL_TITLE}
    dialogCss="send-email-dialog-message"
    dialogPaperCss="send-email-dialog-paper"
    dialogBodycontent={
      <div className="send-email-dialog-body-text">
        <div className="send-email-dialog-alert-icon">
          <img className="icon-image" src={alertIcon} alt="Alert Icon" />
        </div>
        <div className="send-email-dialog-message-text">
          {TECH_SESSION_SEND_EMAIL.SEND_EMAIL_MESSAGE}
        </div>
      </div>
    }
    button1={CANCEL_TEXT}
    button2={TECH_SESSION_SEND_EMAIL.SEND_EMAIL_BUTTON_TEXT}
    cancelButtonId="cancel-send-email-btn"
    submitButtonId="send-email-btn"
    button2Action={onConfirm}
    button1Action={onClose}
  />
);

SendEmailConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default SendEmailConfirmationDialog;
